import React, { useState, useEffect } from "react";
import CardHeader from "./Utils/CardHeaderComponent";
import DropDMultiple from "./InputComponents/DropDMultiple";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import DropDTextMultiple from "./InputComponents/DropDTextMultipleComponent";
interface sdgProps {
  dropdownValues: {
    tab: string;
    inputName: string;
    listValue: string[];
  }[];
  data: {
    contributions: string[];
    contributionsText: string;
    contributionsSensitive: boolean;
  };
  // handleDeletesdg: () => void;
  handleOnChangesdg: (
    e?: React.ChangeEvent<any>,
    dropDown?: {
      name: string;
      value: string[];
    }
  ) => void;
  errors: string[];
}

function SDG({ data, handleOnChangesdg, dropdownValues, errors }: sdgProps) {
  const [isHidden, setIsHidden] = useState(true);
  const toggleVisibility = () => {};
  return (
    <>
      <div className="feedstock-container">
            <h2 className="container-title">Sustainable Development Goals</h2>
        <div className={isHidden ? "visible-content" : "visible-content"}>
          <div className="form-container">
            <div className="error-container">
              {errors.map((error, index) => (
                <div
                  className="error-text"
                  key={index}
                  style={{ marginBottom: "10px" }}
                >
                  {error}
                </div>
              ))}
            </div>
            <div className="question-group-input-first">
              <div className="question-text">
                Does your project contribute to any of the Sustainable
                Development Goals?
              </div>
              <a href="https://sdgs.un.org/goals" target="_blank">
                THE 17 GOALS | Sustainable Development (un.org)
              </a>
              <div className="row">
                <div className="col-12">
                  <DropDTextMultiple
                    listInputs={
                      dropdownValues.filter(
                        (item) => item.inputName == "contributions"
                      )[0].listValue
                    }
                    label={""}
                    inputName={"contributions"}
                    value={data.contributions}
                    handleOnChange={handleOnChangesdg}
                  />
                </div>
                <div className="col-12">
                  <TextConfidential
                    label={"Please explain"}
                    textValid={data.contributionsText.length > 4}
                    textValue={data.contributionsText}
                    textName={"contributionsText"}
                    onChange={handleOnChangesdg}
                    isConfidential={data.contributionsSensitive}
                    confidentialInputName={"contributionsSensitive"}
                    display={data.contributions.length == 0}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SDG;
